export const actionKey = '@@nft';
